export default {
  "root": "_root_v6z2o_1",
  "--clamp": "_--clamp_v6z2o_1",
  "--break-all": "_--break-all_v6z2o_1",
  "--wrap-balance": "_--wrap-balance_v6z2o_1",
  "--variant-title-1": "_--variant-title-1_v6z2o_1",
  "--variant-title-2": "_--variant-title-2_v6z2o_1",
  "--variant-title-3": "_--variant-title-3_v6z2o_1",
  "--variant-title-4": "_--variant-title-4_v6z2o_1",
  "--variant-title-5": "_--variant-title-5_v6z2o_1",
  "--variant-title-6": "_--variant-title-6_v6z2o_1",
  "--variant-featured-1": "_--variant-featured-1_v6z2o_1",
  "--variant-featured-2": "_--variant-featured-2_v6z2o_1",
  "--variant-featured-3": "_--variant-featured-3_v6z2o_1",
  "--variant-body-1": "_--variant-body-1_v6z2o_1",
  "--variant-body-2": "_--variant-body-2_v6z2o_1",
  "--variant-body-3": "_--variant-body-3_v6z2o_1",
  "--variant-caption-1": "_--variant-caption-1_v6z2o_1",
  "--variant-caption-2": "_--variant-caption-2_v6z2o_1",
  "--weight-regular": "_--weight-regular_v6z2o_1",
  "--weight-medium": "_--weight-medium_v6z2o_1",
  "--weight-bold": "_--weight-bold_v6z2o_1",
  "--color-neutral": "_--color-neutral_v6z2o_1",
  "--color-neutral-faded": "_--color-neutral-faded_v6z2o_1",
  "--color-primary": "_--color-primary_v6z2o_1",
  "--color-warning": "_--color-warning_v6z2o_1",
  "--color-positive": "_--color-positive_v6z2o_1",
  "--color-critical": "_--color-critical_v6z2o_1",
  "--color-disabled": "_--color-disabled_v6z2o_1",
  "--decoration-line-through": "_--decoration-line-through_v6z2o_1",
  "--monospace": "_--monospace_v6z2o_1",
  "--variant-title-1--m": "_--variant-title-1--m_v6z2o_1",
  "--variant-title-2--m": "_--variant-title-2--m_v6z2o_1",
  "--variant-title-3--m": "_--variant-title-3--m_v6z2o_1",
  "--variant-title-4--m": "_--variant-title-4--m_v6z2o_1",
  "--variant-title-5--m": "_--variant-title-5--m_v6z2o_1",
  "--variant-title-6--m": "_--variant-title-6--m_v6z2o_1",
  "--variant-featured-1--m": "_--variant-featured-1--m_v6z2o_1",
  "--variant-featured-2--m": "_--variant-featured-2--m_v6z2o_1",
  "--variant-featured-3--m": "_--variant-featured-3--m_v6z2o_1",
  "--variant-body-1--m": "_--variant-body-1--m_v6z2o_1",
  "--variant-body-2--m": "_--variant-body-2--m_v6z2o_1",
  "--variant-body-3--m": "_--variant-body-3--m_v6z2o_1",
  "--variant-caption-1--m": "_--variant-caption-1--m_v6z2o_1",
  "--variant-caption-2--m": "_--variant-caption-2--m_v6z2o_1",
  "--weight-regular--m": "_--weight-regular--m_v6z2o_1",
  "--weight-medium--m": "_--weight-medium--m_v6z2o_1",
  "--weight-bold--m": "_--weight-bold--m_v6z2o_1",
  "--variant-title-1--l": "_--variant-title-1--l_v6z2o_1",
  "--variant-title-2--l": "_--variant-title-2--l_v6z2o_1",
  "--variant-title-3--l": "_--variant-title-3--l_v6z2o_1",
  "--variant-title-4--l": "_--variant-title-4--l_v6z2o_1",
  "--variant-title-5--l": "_--variant-title-5--l_v6z2o_1",
  "--variant-title-6--l": "_--variant-title-6--l_v6z2o_1",
  "--variant-featured-1--l": "_--variant-featured-1--l_v6z2o_1",
  "--variant-featured-2--l": "_--variant-featured-2--l_v6z2o_1",
  "--variant-featured-3--l": "_--variant-featured-3--l_v6z2o_1",
  "--variant-body-1--l": "_--variant-body-1--l_v6z2o_1",
  "--variant-body-2--l": "_--variant-body-2--l_v6z2o_1",
  "--variant-body-3--l": "_--variant-body-3--l_v6z2o_1",
  "--variant-caption-1--l": "_--variant-caption-1--l_v6z2o_1",
  "--variant-caption-2--l": "_--variant-caption-2--l_v6z2o_1",
  "--weight-regular--l": "_--weight-regular--l_v6z2o_1",
  "--weight-medium--l": "_--weight-medium--l_v6z2o_1",
  "--weight-bold--l": "_--weight-bold--l_v6z2o_1",
  "--variant-title-1--xl": "_--variant-title-1--xl_v6z2o_1",
  "--variant-title-2--xl": "_--variant-title-2--xl_v6z2o_1",
  "--variant-title-3--xl": "_--variant-title-3--xl_v6z2o_1",
  "--variant-title-4--xl": "_--variant-title-4--xl_v6z2o_1",
  "--variant-title-5--xl": "_--variant-title-5--xl_v6z2o_1",
  "--variant-title-6--xl": "_--variant-title-6--xl_v6z2o_1",
  "--variant-featured-1--xl": "_--variant-featured-1--xl_v6z2o_1",
  "--variant-featured-2--xl": "_--variant-featured-2--xl_v6z2o_1",
  "--variant-featured-3--xl": "_--variant-featured-3--xl_v6z2o_1",
  "--variant-body-1--xl": "_--variant-body-1--xl_v6z2o_1",
  "--variant-body-2--xl": "_--variant-body-2--xl_v6z2o_1",
  "--variant-body-3--xl": "_--variant-body-3--xl_v6z2o_1",
  "--variant-caption-1--xl": "_--variant-caption-1--xl_v6z2o_1",
  "--variant-caption-2--xl": "_--variant-caption-2--xl_v6z2o_1",
  "--weight-regular--xl": "_--weight-regular--xl_v6z2o_1",
  "--weight-medium--xl": "_--weight-medium--xl_v6z2o_1",
  "--weight-bold--xl": "_--weight-bold--xl_v6z2o_1"
};import "ni:sha-256;fpyJ2kcgGOazGnG3qui28aG7LuixFIwKeYbjANSZrRk";